
<div class="logo" style="padding:9px">
	<a [routerLink]="['/']" class="logo-normal">
        <div class="logo-normal text-center">
            <img height="60px" src="../assets/img/logos/SIOPEN-R-NET-Logo.png" /><b>{{instance}}</b>
        </div>
	</a>
</div>

<div class="sidebar-wrapper">

    <div *ngIf="!isLoggedIn()" class="user text-center">
        <button class="btn btn-primary" (click)="login()">Login</button>
    </div>
    <div *ngIf="isLoggedIn()" class="user">
        <div class="photo">
            <i class="fa fa-user fa-3x"></i>
        </div>
        <div class="info">
            <a data-toggle="collapse" href="#collapseExample" class="collapsed">
                <span>
                    {{userInfo().name}}
                </span>
            </a>
            <div class="clearfix"></div>
            <div class="collapse" id="collapseExample">
                <ul class="nav">
                    <li>
                        <a>
                            <span class="sidebar-mini">UN</span>
                            <span class="sidebar-normal">{{userInfo().username}}</span>
                        </a>
                    </li>
                    <li>
                        <a href="https://account.activedirectory.windowsazure.com/ChangePassword.aspx">
                            <span class="sidebar-mini">CP</span>
                            <span class="sidebar-normal">Change Password</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <span class="sidebar-mini">RO</span>
                            <span class="sidebar-normal">
                                <ul style="list-style:none;">
                                    <li *ngFor="let role of userInfo().idTokenClaims.roles">{{role}}</li>
                                </ul>
                            </span>
                        </a>
                    </li>
                    <li class="text-center" style="padding-top:10px">
                        <button class="btn btn-danger" (click)="logout()">Logout</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    
	<!--<div *ngIf="isNotMobileMenu()">
        <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input type="text" value="" class="form-control" placeholder="Search...">
            </div>
        </form>
        <ul class="nav nav-mobile-menu">
            <li>
                <a href="#stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
                    <i class="ti-panel"></i>
                    <p>Stats</p>
                </a>
            </li>
            <li class="dropdown">
                <a href="#notifications" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
                    <i class="ti-bell"></i>
                    <span class="notification">5</span>
                    <p class="hidden-md hidden-lg">
                        Notifications
                    </p>
                </a>
                <ul class="dropdown-menu">
                    <li><a href="#not1">Notification 1</a></li>
                    <li><a href="#not2">Notification 2</a></li>
                    <li><a href="#not3">Notification 3</a></li>
                    <li><a href="#not4">Notification 4</a></li>
                    <li><a href="#another">Another notification</a></li>
                </ul>
            </li>
            <li>
                <a class="btn-rotate">
                    <i class="ti-settings"></i>
                    <p class="hidden-md hidden-lg">
                        Settings
                    </p>
                </a>
            </li>
        </ul>
    </div>-->
    <ul class="nav">
        <li routerLinkActive="active" *ngFor="let menuitem of menuItems">
            <!--If is a single link-->
            <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'">
                <i class="{{menuitem.icontype}}"></i>
                <p>{{menuitem.title}}</p>
            </a>
            <!--If it have a submenu-->
            <a data-toggle="collapse" href="#{{menuitem.title}}" *ngIf="menuitem.type === 'sub'">
                <i class="{{menuitem.icontype}}"></i>
                <p>{{menuitem.title}}<b class="caret"></b></p>
            </a>

            <!--Display the submenu items-->
            <div id="{{menuitem.title}}" class="collapse" *ngIf="menuitem.type === 'sub'">
                <ul class="nav">
                    <li routerLinkActive="active" *ngFor="let childitem of menuitem.children">
                        <a [routerLink]="[menuitem.path, childitem.path]">
                            <span class="sidebar-mini">{{childitem.ab}}</span>
                            <span class="sidebar-normal">{{childitem.title}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div>
